export const clientStatusFilters = [
    "Всички",
    "Свързан",
    "Частичен",
    "Рисков клиент",
] as const;

export const clientChannelFilters = [
    "Всички",
    "Магазин",
    "WooCommerce",
    "Expo",
] as const;

export const clientInboxFilters = [
    "Всички",
    "Висок приоритет",
    "Идентичност",
    "Лоялност",
    "Качество",
] as const;
